/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Explorer_Display_Delete_Records_TextInputs */

const en_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Are you sure you want to delete ${i?.count} selected record(s)?`)
};

const fr_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voulez-vous supprimer ${i?.count} enregistrement(s) selectionne(s) ?`)
};

const de_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Möchten Sie die ausgewählten Datensätze ${i?.count} wirklich löschen?`)
};

const it_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sei sicuro di voler eliminare ${i?.count} record selezionati?`)
};

const ru_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вы уверены, что хотите удалить выбранную(ые) запись(и) ${i?.count}?`)
};

const es_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Está seguro de que desea eliminar ${i?.count} los registros seleccionados?`)
};

const zh_cn2_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`您确定要删除 ${i?.count} 选定的记录吗？`)
};

const ja_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`選択したレコード ${i?.count} を削除してもよろしいですか?`)
};

const pt_pt2_explorer_display_delete_records_text = /** @type {(inputs: Explorer_Display_Delete_Records_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tem certeza de que deseja excluir o(s) registro(s) selecionado(s) ${i?.count}?`)
};

/**
* | output |
* | --- |
* | "Are you sure you want to delete {count} selected record(s)?" |
*
* @param {Explorer_Display_Delete_Records_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_records_text = /** @type {((inputs: Explorer_Display_Delete_Records_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Records_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_delete_records_text(inputs)
	if (locale === "de") return de_explorer_display_delete_records_text(inputs)
	if (locale === "it") return it_explorer_display_delete_records_text(inputs)
	if (locale === "ru") return ru_explorer_display_delete_records_text(inputs)
	if (locale === "es") return es_explorer_display_delete_records_text(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_delete_records_text(inputs)
	if (locale === "ja") return ja_explorer_display_delete_records_text(inputs)
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्या आप वाकई चयनित रिकॉर्ड (या रिकॉर्ड) को हटाना चाहते हैं?")
	if (locale === "pt-PT") return pt_pt2_explorer_display_delete_records_text(inputs)
	return en_explorer_display_delete_records_text(inputs)
});